
const digest = '24062c28c3a475782a6e9bade11a0a6e11f025879f878f2c84b038910b0dae14';
const classes = {"wrapper":"_wrapper_1tpq3_1","wrapperCenter":"_wrapperCenter_1tpq3_8","title":"_title_1tpq3_11","content":"_content_1tpq3_16","noPadding":"_noPadding_1tpq3_21","item":"_item_1tpq3_24","center":"_center_1tpq3_29","label":"_label_1tpq3_32"};
const css = `._wrapper_1tpq3_1 {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: Poppins, sans-serif;
  gap: 10px;
}
._wrapper_1tpq3_1._wrapperCenter_1tpq3_8 {
  align-items: center;
}
._wrapper_1tpq3_1 ._title_1tpq3_11 {
  color: #212357;
  font-weight: 600;
  font-size: 16px;
}
._wrapper_1tpq3_1 ._content_1tpq3_16 {
  background-color: #fff;
  border-radius: 15px;
  padding: 18px;
}
._wrapper_1tpq3_1 ._content_1tpq3_16._noPadding_1tpq3_21 {
  padding: 0;
}
._wrapper_1tpq3_1 ._content_1tpq3_16 ._item_1tpq3_24 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
._wrapper_1tpq3_1 ._content_1tpq3_16 ._item_1tpq3_24._center_1tpq3_29 {
  text-align: right;
}
._wrapper_1tpq3_1 ._content_1tpq3_16 ._item_1tpq3_24 ._label_1tpq3_32 {
  min-width: 80px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  